<template>
  <tr v-show="showFeature">
    <td>
      <div class="tag-list-td">
        <router-link :to="{ path: '/tag/' + tagId + '/place/' + feature.id }">
          {{ feature.name }}
          <br />
          <div class="details-div">
            <span v-html="lightData" class="small-text"></span>
          </div>
        </router-link>
      </div>
    </td>
    <td class="tag-list-dist" :aria-label="'Afstand til ' + feature.name">
      {{ createDistance }}
    </td>
  </tr>
</template>

<script>
import ContentController from "@/assets/ContentController.js";
import DataFunctions from "@/assets/DataFunctions.js";
import MarkerGenerator from "@/assets/MarkerGenerator.js";

export default {
  data() {
    return {
      lightData: "",
      showFeature: false,
    };
  },
  props: {
    feature: {
      type: Object,
      required: true,
    },
    tagId: {
      type: String,
      required: true,
    },
  },
  watch: {
    feature() {
      this.createLightData();
    },
  },
  created: function() {
    this.createLightData();
    this.checkIfActive();
  },
  computed: {
    createDistance() {
      if (this.feature.distance == "?") {
        return this.feature.distance;
      }
      if (this.feature.distance < 1000) {
        return this.feature.distance + " m";
      } else {
        var km = this.feature.distance / 1000;
        km = km.toFixed(1);
        return km + " km";
      }
    },
  },
  methods: {
    checkIfActive() {
      this.showFeature = MarkerGenerator.showFeature(this.feature);
    },

    createLightData() {
      this.lightData = ContentController.generateLightContent(this.feature, "span");
      DataFunctions.findPrimaryTag(this.feature).then((featurePrimaryTag) => {
        if (featurePrimaryTag != undefined) {
          if (featurePrimaryTag.id != this.tagId) {
            this.lightData = featurePrimaryTag.name + " | " + this.lightData;
          }
          this.lightData = this.lightData.substring(0, this.lightData.lastIndexOf("|"));

          var div = document.createElement("div");
          div.innerHTML = this.lightData;
          var text = div.textContent || div.innerText || "";

          if (text.length > 100) {
            this.lightData = this.lightData.substring(0, 100) + "...";
          }
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
td {
  padding-left: 0px;
  padding-right: 10px;
}

.tag-list-td {
  overflow: hidden;
}

.tag-list-dist {
  width: 60px;
  text-align: right;
  vertical-align: middle;
  padding-right: 0px !important;
}
</style>
